package gr.tech.site.data

import gr.tech.site.models.PodcastEntry

val PODCAST_ENTRIES = listOf<PodcastEntry>(

    PodcastEntry(
        title = "A Convo With JJ Crossan and Clovis McCary of Advanced Nutrients",
        thumbnailId = "RVXp_0-qgMc",
        link = "https://youtu.be/RVXp_0-qgMc?si=PABbtnbnJJKSshEm",
        desc = "Clovis McCary and JJ Crossan from Advanced Nutrients share their journeys and offer honest insights on cultivation challenges, facility management, and innovative growing technologies.",
        date = "2026-01-23"
    ),

    PodcastEntry(
        title = "Money Talks Podcast: Episode 1 with Mike from Real McCoy Farms",
        thumbnailId = "dTsN0hhBXhw",
        link = "https://youtu.be/dTsN0hhBXhw?si=WOu8HqySclRNX8aA",
        desc = "FreeMoney sits down with Real McCoy Farms to discuss his incredible journey as a cannabis grower and his unforgettable story of taking urine tests while playing college football.",
        date = "2026-01-06"
    ),

    PodcastEntry(
        title = "A Conversation With Big Mike Of Advanced Nutrients",
        thumbnailId = "kwmS_IuzirY",
        link = "https://youtu.be/kwmS_IuzirY?si=HRJZogc3JRrqh8wL",
        desc = "What a pleasure to sit down with Big Mike, the founder and CEO of Advanced Nutrients, one of the most recognized nutrient brands in the global cannabis cultivation industry.",
        date = "2026-03-12"
    ),

    PodcastEntry(
        title = "Building One Of Michigan's Premiere Cannabis Brands",
        thumbnailId = "UVmP20wowOw",
        link = "https://youtu.be/UVmP20wowOw?si=2ujzT8uNlhsbMsoj",
        desc = "We sat down with Brandon, the direct of cultivation at Primitiv. He is responsible for the company's controlled-environment growing techniques, genetics selection, and crop steering methods, focusing on premium quality cannabis.",
        date = "2026-01-21"
    ),

    PodcastEntry(
        title = "Talkin Texas With Colton Luther",
        thumbnailId = "BDonXhcxWPE",
        link = "https://youtu.be/BDonXhcxWPE?si=mv0Gvm--bUVafge5",
        desc = "Colton Luther, a Texas cannabis advocate and former hockey player, shares his journey from battling brain injuries to becoming a key player in the state's hemp industry. He discusses the recent political battles against hemp banning legislation, highlighting the community's successful advocacy efforts that led to a governor's veto.",
        date = "2025-07-10"
    ),

    PodcastEntry(
        title = "Money Talks Podcast: Episode 8 with Liam Spenser of Aroya",
        thumbnailId = "4j8vuVwVGUc",
        link = "https://youtu.be/4j8vuVwVGUc?si=XWUzSBwSnaQrhdQG",
        desc = "Liam's cannabis journey started at 13 in Florida. He became a young entrepreneur and in college traded in his bong for a hydroponic setup, believing if you're going to grow something, it might as well be like a plant wizard's garden.",
        date = "2025-02-21"
    ),

    PodcastEntry(
        title = "A Cannabis Legend Finally Tells His Story",
        thumbnailId = "8Dh95errzeY",
        link = "https://youtu.be/8Dh95errzeY?si=hpimQ6_Cx7RRftpr",
        desc = "Johnny, a seasoned industry veteran who shares his incredible journey from Humboldt County trimmers to multi-million dollar cannabis operations.",
        date = "2025-04-18"
    ),

    PodcastEntry(
        title = "Marketing Secrets In The Cannabis Space",
        thumbnailId = "9C9_NtXmHuU",
        link = "https://youtu.be/9C9_NtXmHuU?si=qOTcv28nf67MJtEN",
        desc = "Krysta Jones and Sanja Ganja are the dynamic duo behind The High Country Girls, and trust me, they're not just in the cannabis space, they're shaping it. ",
        date = "2026-04-02"
    ),

    PodcastEntry(
        title = "Money Talks Podcast: Episode 11 with Cat Franklin",
        thumbnailId = "du0usCBjsj8",
        link = "https://youtu.be/du0usCBjsj8?si=fYIKsGSbAiLJpp-a",
        desc = "Cat, a long-time cannabis industry veteran, shares her journey from underground seed seller to legal cannabis operator, highlighting the challenges of being a woman in the industry.",
        date = "2025-03-14"
    ),

    PodcastEntry(
        title = "Money Talks Podcast: Episode 10 with Will Batt of Canna Cribs",
        thumbnailId = "HHCPIxTzDAw",
        link = "https://youtu.be/HHCPIxTzDAw?si=LY1bQnBPb4mbnmOF",
        desc = "Will Batt shares his journey from working on organic farms in California to becoming a professional cultivator and consultant, and the value of educational resources like Canna Cribs for growers.",
        date = "2025-03-03"
    ),

    /* ----- Adjust Lines ----- */

    PodcastEntry(
        title = "Money Talks Podcast: Episode 2 with Adam from Fund Canna",
        thumbnailId = "ODcnGuuQUy8",
        link = "https://youtu.be/ODcnGuuQUy8?si=Emy4-ye-WML6O37j",
        desc = "We had the incredible opportunity to sit down with Adam Stettner, CEO of Fund Canna at MJBizDaily 2024! Adam shared his journey from finance to becoming one of the top lenders in the cannabis industry.",
        date = "2025-01-10"
    ),

    PodcastEntry(
        title = "Money Talks Podcast: Episode 3 with David Cohen",
        thumbnailId = "iSSGVW0aBKw",
        link = "https://youtu.be/iSSGVW0aBKw?si=TN_KfG0ARL6Ds3bg",
        desc = "Had an awesome chat with our very own David Cohen. He discussed his Boston beginnings, leading and scaling businesses in the tech and lighting industries, and his recent involvement with Green Rebates.",
        date = "2025-01-17"
    ),

    PodcastEntry(
        title = "Money Talks Podcast: Episode 4 with Shiloh Massive",
        thumbnailId = "7NEbOPfkCCY",
        link = "https://youtu.be/7NEbOPfkCCY?si=BtpV9zr6NWMW49xG",
        desc = "What an honor to sit down with the one and only Shiloh Massive, a true pioneer in the growing community. He told us about the craziness that was cannabis in the 1990s, and how he feels about the evolution of the industry.",
        date = "2025-01-24"
    ),

    PodcastEntry(
        title = "Money Talks Podcast: Episode 5 With Michael Beck of Royal Gold",
        thumbnailId = "jnvT8ZCMYJI",
        link = "https://youtu.be/jnvT8ZCMYJI?si=UTAEZS1nhbHDNsLU",
        desc = "FreeMoney was lucky enough to sit down with Michael Beck of Royal Gold who enlightened us about his Michigan beginnings, Humboldt roots, and expertise as one of the premier soil distributors in cannabis.",
        date = "2025-02-07"
    ),

    PodcastEntry(
        title = "Money Talks Podcast: Episode 6 with Rick from Mosca Seeds",
        thumbnailId = "jNCv2Reojyc",
        link = "https://youtu.be/jNCv2Reojyc?si=4wsjcyFu53a7iY7P",
        desc = "Rick with Mosca Seeds is a guest who needs no fancy introduction. His work speaks for itself, and we were elated to have him sit down with us for a short but sweet episode about how his admiration for cannabis began.",
        date = "2025-02-07"
    ),

    PodcastEntry(
        title = "Money Talks Podcast: Episode 7 With Nick Pastushan of ScynceLED",
        thumbnailId = "OJlfEC8r1U0",
        link = "https://youtu.be/OJlfEC8r1U0?si=gO8d13ezuiw67_-T",
        desc = "Nick comes from a background in Wall Street and corporate finance, and was drawn to the cannabis industry by the strong technology and differentiation of certain companies, like the lighting and airflow solutions he has invested in.",
        date = "2025-02-13"
    ),

    PodcastEntry(
        title = "Money Talks Podcast: Episode 9 with Justin Kwan of Grower's Choice",
        thumbnailId = "oTIVPMopMmM",
        link = "https://youtu.be/oTIVPMopMmM?si=rOqXburw-mawAjBT",
        desc = "Justin's career in cannabis started in 2005 when he began working at a hydroponics store after dropping out of college, eventually producing his own cannabis and partnering with the owner of Grower's Choice.",
        date = "2025-03-01"
    ),

    PodcastEntry(
        title = "Interview with Shiloh Massive",
        thumbnailId = "XEZSg58odE4",
        link = "https://youtu.be/XEZSg58odE4?si=w4CjoDN8HllH8acC",
        desc = "FreeMoney sat down with another legend. Shiloh Massive explains the craziness of the cannabis industry in the northwest during the 1990s. This guy has stories for days.",
        date = "2025-01-21"
    ),

)

object PODCAST_LIST {

    fun getPopular(): List<PodcastEntry> = PODCAST_ENTRIES

    fun getNewest(): List<PodcastEntry> = PODCAST_ENTRIES.sortedByDescending { it.date }
}

